import React from 'react'
import styled from 'styled-components'

import { TrackingEmptyBanner } from 'features/catalog/components/TrackingEmptyBanner/TrackingEmptyBanner'
import Overview from 'features/catalog/features/overview/Container'
import { FocusListOption } from 'features/catalog/types'
import { initialChartStoreState } from 'features/charts/store'
import { Filters } from 'types/project'

interface FocusDetailProps {
  lens: string
  /** The item-scoped filters (page-level filters + this row's own identity
   * [+ country]) — computed once in `CatalogDetail` (features/detail/
   * Container.tsx), which also feeds it to the header's View-in-Feedback/
   * Charts/Keywords links, rather than duplicating the computation here. */
  localFilterValues: Filters
  item: FocusListOption
  subthemeName: string | null
  setSubthemeValue: (value: string | null) => void
  isLoading?: boolean
}

const CatalogDetailContent: React.FC<FocusDetailProps> = ({
  item,
  lens,
  localFilterValues,
  subthemeName,
  setSubthemeValue,
  isLoading = false,
}) => {
  const chartId = '6_4_17_sentiment'
  const tier1 = lens

  const dashboardControls = JSON.parse(
    JSON.stringify(initialChartStoreState.dashboardControls[0]),
  )

  dashboardControls.legend = true

  // Gates on n_posts (filter-scoped), not total_review_count, which
  // ignores Yogi's data-window floor so stays >0 for products whose
  // only reviews predate it (PROD-6009). Side effect: a user-narrowed
  // filter dropping Records to 0 now also shows the banner.
  const isEmpty = item.n_posts === 0

  return (
    <>
      <Content>
        {isEmpty && <TrackingEmptyBanner />}
        <MainBody>
          <Overview
            item={item}
            filterValues={localFilterValues}
            tier1={tier1}
            chartId={chartId}
            subthemeName={subthemeName}
            setSubthemeValue={setSubthemeValue}
            isLoading={isLoading}
          />
        </MainBody>
      </Content>
    </>
  )
}

const Content = styled.div`
  width: 100%;
`

const MainBody = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
`

export default CatalogDetailContent
